var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box flex-default"},[_c('h2',[_vm._v("404")]),_c('p',[_vm._v("界面不存在")]),_c('button',{attrs:{"type":"button"},on:{"click":_vm.gotoIndex}},[_vm._v("返回登录页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }